type ScreenWakeLockSentinel = {
	release: () => Promise<void>;
	released: boolean;
	addEventListener: (type: "release", callback: () => void) => void;
};

// Ten seconds of black video. A one-frame clip does not move currentTime, so iPhone still sleeps.
const SILENT_MP4 = "data:video/mp4;base64,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";

let holding = false;
let acquiring = false;
let sentinel: ScreenWakeLockSentinel | null = null;
let retryTimer: number | null = null;
let keepAliveTimer: number | null = null;
let keepAwakeVideo: HTMLVideoElement | null = null;
let lastVideoTime = -1;
let lastVideoAdvanceAt = 0;

/** Keep the phone screen on while a game is open, including unattended bonus play. */
export function HoldScreenAwake(): void {
	if (!holding) {
		holding = true;
		document.addEventListener("visibilitychange", OnScreenWakeLockVisibility);
		document.addEventListener("pointerdown", OnScreenWakeLockGesture, { capture: true, passive: true });
		document.addEventListener("touchstart", OnScreenWakeLockGesture, { capture: true, passive: true });
		document.addEventListener("keydown", OnScreenWakeLockGesture, { capture: true });
		keepAliveTimer = window.setInterval(KeepScreenAwake, 1000);
	}
	KeepScreenAwake();
}

export function ReleaseScreenAwake(): void {
	holding = false;
	document.removeEventListener("visibilitychange", OnScreenWakeLockVisibility);
	document.removeEventListener("pointerdown", OnScreenWakeLockGesture, true);
	document.removeEventListener("touchstart", OnScreenWakeLockGesture, true);
	document.removeEventListener("keydown", OnScreenWakeLockGesture, true);
	if (retryTimer != null) {
		window.clearTimeout(retryTimer);
		retryTimer = null;
	}
	if (keepAliveTimer != null) {
		window.clearInterval(keepAliveTimer);
		keepAliveTimer = null;
	}
	keepAwakeVideo?.pause();
	const current = sentinel;
	sentinel = null;
	void current?.release()?.catch(() => undefined);
}

function OnScreenWakeLockVisibility(): void {
	if (document.visibilityState === "visible") {
		KeepScreenAwake();
	}
}

function OnScreenWakeLockGesture(): void {
	KeepScreenAwake();
	// The storefront cannot hear taps inside this frame. Tell it the player is still here.
	if (window.parent && window.parent !== window) {
		window.parent.postMessage({ type: "player-active" }, "*");
	}
}

function KeepScreenAwake(): void {
	if (!holding || document.visibilityState !== "visible") {
		return;
	}
	PlayKeepAwakeVideo();
	void AcquireScreenWakeLock();
}

function ScheduleReacquire(): void {
	if (!holding || retryTimer != null) {
		return;
	}
	retryTimer = window.setTimeout(() => {
		retryTimer = null;
		KeepScreenAwake();
	}, 500);
}

async function AcquireScreenWakeLock(): Promise<void> {
	if (sentinel?.released) {
		sentinel = null;
	}
	if (!holding || sentinel || acquiring || document.visibilityState !== "visible") {
		return;
	}
	const wakeLock = (navigator as Navigator & {
		wakeLock?: { request: (type: "screen") => Promise<ScreenWakeLockSentinel> };
	}).wakeLock;
	if (!wakeLock) {
		return;
	}
	acquiring = true;
	try {
		const lock = await wakeLock.request("screen");
		if (!holding) {
			void lock.release().catch(() => undefined);
			return;
		}
		sentinel = lock;
		lock.addEventListener("release", () => {
			if (sentinel === lock) {
				sentinel = null;
			}
			if (holding && document.visibilityState === "visible") {
				ScheduleReacquire();
			}
		});
	} catch {
		// The storefront iframe rejects this unless it has allow="screen-wake-lock".
		// The looping video is what still holds an iPhone.
	} finally {
		acquiring = false;
	}
}

/** A playing video keeps iPhone awake. Android needs the Wake Lock above. */
function PlayKeepAwakeVideo(): void {
	const video = EnsureKeepAwakeVideo();
	const now = performance.now();
	const advanced = video.currentTime !== lastVideoTime;
	if (advanced) {
		lastVideoTime = video.currentTime;
		lastVideoAdvanceAt = now;
	}
	const stalled = lastVideoAdvanceAt > 0 && !advanced && now - lastVideoAdvanceAt > 1500;
	if (!video.paused && !video.ended && !stalled) {
		return;
	}
	if (stalled || video.ended) {
		try {
			video.currentTime = 0;
		} catch {
			// Seeking before metadata is ready throws. The next tick retries.
		}
	}
	void video.play().catch(() => undefined);
}

function EnsureKeepAwakeVideo(): HTMLVideoElement {
	if (keepAwakeVideo) {
		return keepAwakeVideo;
	}

	const video = document.createElement("video");
	video.muted = true;
	video.defaultMuted = true;
	video.loop = true;
	video.autoplay = true;
	video.playsInline = true;
	video.setAttribute("playsinline", "true");
	video.setAttribute("webkit-playsinline", "true");
	video.disablePictureInPicture = true;
	video.src = SILENT_MP4;
	// iPhone ignores display:none and opacity:0. This stays inside the viewport and does not take taps.
	video.style.cssText = "position:fixed;left:50%;top:50%;width:12px;height:12px;opacity:0.05;transform:translate(-50%,-50%);pointer-events:none;z-index:2147483647;";
	document.body.appendChild(video);
	const resume = () => {
		if (!holding || document.visibilityState !== "visible") {
			return;
		}
		void video.play().catch(() => undefined);
	};
	video.addEventListener("pause", resume);
	video.addEventListener("ended", resume);
	video.addEventListener("stalled", resume);
	video.addEventListener("waiting", resume);
	keepAwakeVideo = video;
	return video;
}
